import { Col, Row, Tab } from "react-bootstrap";
import InvoiceCard from "./InvoiceCard";
import AlertDialog from "./AlertDialog";
import messages from "../views/Dashboard/Dashboard.messages";
import InvoiceCardSkeleton from "./InvoiceCardSkeleton";
import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

const DashboardPane = (props) => {
    const jobs = props.jobs;
    const lng = props.intl.formatMessage;
    const current = props.current;
    const type = props.type;
    const onClick = props.onClick;
    const registerJobRef = props.registerJobRef;
    const emptyResultMessage = props.emptyResultMessage;
    const showSkeleton = jobs === false || !current;

    const resolveContent = () => {
        if (jobs.length > 0) {
            return jobs.map(row => (
                <button
                    id={`govidjob-${row.jobid}`}
                    ref={(el) => registerJobRef?.(row.jobid, el)}
                    key={row.jobid}
                    className="btn invoice-card"
                    onClick={(e) => onClick(e, row.dpid)}>
                    <InvoiceCard job={row}/>
                </button>
            ));
        } else if (jobs instanceof Error) {
            return (
                <AlertDialog
                    message={lng(messages.govidSearchError)}
                    type={'danger'}
                />
            )
        } else {
            return (
                <AlertDialog
                    message={emptyResultMessage}
                    type={'light'}
                />
            )
        }
    }

    return (
        <Tab.Pane
            id={type}
            eventKey={type}
            className="show"
            role="tabpanel"
            aria-labelledby={`tab-${type}`}
            tabIndex={0}
        >
            <Row className="g-5 mt-0 bg-light">
                <Col>
                    {!showSkeleton && resolveContent()}
                    {showSkeleton && <InvoiceCardSkeleton count={5} />}
                </Col>
            </Row>
        </Tab.Pane>
    )
}

DashboardPane.propTypes = {
    intl: PropTypes.object.isRequired,
    jobs: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
        PropTypes.instanceOf(Error)
    ]).isRequired,
    current: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    registerJobRef: PropTypes.func,
    emptyResultMessage: PropTypes.string.isRequired
};

export default injectIntl(DashboardPane);
